import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { SelectField, OptionField } from './../../../../components/ui/input';
import { CountryService } from './../../../../services';

class CountrySelect extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      entities: []
    };
  }

  /**
  * @Event
  * @Description: Is invoked immediately after a component is mounted.
  */
  componentDidMount(){
    this._All();
  }

  /*
  ** @Service
  ** @Description: List all countries
  */

  _All = () => {
    CountryService.list().then((response) => {

      // @Sate
      this.setState({ entities: response.countries });

      // @Find
      // @Description: Find country default
      let countryDefault = response.countries.find((country) => country.default === true);

      // if(!countryDefault && response.countries.length > 0){
      //   countryDefault = response.countries[0];
      // }

      // @Event
      if(this.props.onLoad){
        this.props.onLoad(countryDefault);
      }

    });
  }

  /*
  ** @Render
  */

  render() {

    const { entities } = this.state;

    return(
      <SelectField { ...this.props }>
        { entities.length > 0 ? (
          <React.Fragment>
            <OptionField value="-1">{this.props.t('field.option_field.select')}</OptionField>
            { entities.map((entity, index) => {
              return(
                <OptionField key={index} value={entity._id}>
                  {entity.name} [{entity.alpha2Code}]
                </OptionField>
              )
            })}
          </React.Fragment>
        ) : (
          <OptionField value="-1">{this.props.t('field.option_field.select')}</OptionField>
        )}
      </SelectField>
    )
  }

}

CountrySelect.propTypes = {
  onLoad: PropTypes.func
};

export default withTranslation()(CountrySelect);
